import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { TraineesPrief } from "../../Interfaces/ResponsesData";
import { Notify } from "../../Handlers/Notifications";

export class ClientsListVM extends InterActive{
    private clientsList:TraineesPrief[] = []
    private searchTerm:string = ''
    private stoped:boolean = false
    private loaded:boolean =false

    public get List():TraineesPrief[] { return this.clientsList }
    public set Search(value:string){ this.searchTerm = value; this.search(); this.update() }

    constructor (){
        super()
    }

    public getList(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.trainees({})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.clientsList = response.data.data
                                this.update()
                            }else Notify({type:'danger' , title:'حدثت مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{  Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }

    public async search(){
        try{
            const response = await ApiRequest.trainees({search:this.searchTerm})
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.clientsList = [...response.data.data]
                        this.stoped = false
                        this.update()
                    }else Notify({type:'danger' , title:'حدثت مشكلة' , body:response.data.messege})
                }else Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{  Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
    }
    public async addClients(){
        if(!this.loaded){
            this.loaded = true
            if(!this.stoped){
                try{
                    const id = this.clientsList.length>0?this.clientsList[this.clientsList.length-1].id:''
                    const response = await ApiRequest.trainees({search:this.searchTerm,id:id})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length == 0){
                                    this.stoped = true
                                    this.update()
                                }else {
                                    this.clientsList = [...this.clientsList,...response.data.data]
                                    this.update()
                                }
                            }else {
                                if(response.data.error_code ==='D0001'){
                                    this.stoped = true
                                    this.update() 
                                }else Notify({type:'danger' , title:'حدثت مشكلة' , body:response.data.messege})
                            }
                        }else Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{  Notify({type:'danger' , title:'حدثت مشكلة' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
        
            }
            this.loaded = false
        }

    }

}